import './styles.scss';

import React from 'react';

import {AlertTypeDTO} from 'kashable-mobile-common';

import {TryAgainCard} from '../../../../TryAgainCard/TryAgainCard';
import {AppLink} from '../../../AppLink/AppLink';
import {AppSpinner} from '../../../AppSpinner/AppSpinner';

import {ModalAlertPreview} from './components/ModalAlertPreview/ModalAlertPreview';

import {useHistory} from 'react-router-dom';

interface HeaderNotificationsModalProps {
    notifications: AlertTypeDTO[];
    error: boolean;
    loading: boolean;
    onClose: () => void;
    onRetry: () => void;
}

export const HeaderNotificationsModal = ({
    notifications,
    error,
    loading,
    onRetry,
    onClose,
}: HeaderNotificationsModalProps) => {
    const history = useHistory();

    const onView = (gid?: number) => {
        history.push(`/home/alerts/${gid || ''}`);
        onClose();
    };

    if(loading){
        return (
            <div className='header-notifications-modal'>
                <AppSpinner />
            </div>
        );
    } else {
        return (
            <div className='header-notifications-modal'>
                {error ? (
                        <TryAgainCard onRetry={onRetry} />
                    ) : (
                        <div>
                            {notifications?.length ? (
                                <div className='header-notifications-modal__list'>
                                    {notifications.map((item) => (
                                        <ModalAlertPreview
                                            key={item.gid}
                                            data={item}
                                            onClick={() => onView(item.gid)}
                                        />
                                    ))}
                                </div>
                            ) : (
                                <div className='header-notifications-modal__empty'>
                                    No new messages for you.
                                    <br />
                                    Please stay in touch.
                                </div>
                            )}
                            <div className='header-notifications-modal__footer'>
                                <AppLink action='notification-view-all' onClick={() => onView()}>View All</AppLink>
                            </div>
                        </div>
                    )}
            </div>
        );
    }

}